export default "__VITE_ASSET__CeSijBJG__"